import { Theme } from "@mui/material/styles";

export interface SupplyColorCodingOptions {
  value: number;
  targetValue: number | null;
  theme: Theme;
}

export const getSupplyCellBackgroundColor = ({
  value,
  targetValue,
  theme,
}: SupplyColorCodingOptions): string | undefined => {
  if (targetValue === null || targetValue === undefined || isNaN(targetValue)) {
    return undefined;
  }

  if (value === 0) {
    return theme.palette.atomic.red2; // slightly darker red for zero
  }

  if (value > 3 * targetValue) {
    return theme.palette.atomic.purple1; // purple for > 3x target
  }

  if (value >= targetValue) {
    return theme.palette.atomic.green1; // green for >= target
  }

  if (value >= 0.5 * targetValue) {
    return theme.palette.atomic.orange1; // yellow/orange for >= 1/2x target
  }

  if (value > 0) {
    return theme.palette.atomic.red1; // light red for > 0 but < 1/2x target
  }

  return theme.palette.atomic.red2; // slightly darker red for zero (fallback)
};

export const getWOSMeasureKey = (
  base: "target" | "starting" | "ending",
  dateHierarchy: string
): string => {
  const period = getPeriodLabel(dateHierarchy);
  return `${base} ${period.toLowerCase()} of supply`;
};

export const getPeriodLabel = (dateHierarchy: string): string => {
  if (dateHierarchy.includes("day")) return "Days";
  if (dateHierarchy.includes("week")) return "Weeks";
  if (dateHierarchy.includes("month")) return "Months";
  return "Periods";
};
